export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9732.08d08894.jpg";